import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { GridModule } from '@df/ui/atomic/atom/grid/grid.module';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { iconsOptions } from 'projects/app-default/src/app/styles/cms.config';

export namespace NCmsInformationTiles {
    export const componentId = 'information-tiles';
    export interface IComponentData extends NICmsContentComponent.IData {
        tiles?: ITile[];
    }

    /**
     * Link interface
     */
    export interface ITile {
        icon: string;
        title: string;
        description?: string;
        copy?: string;
    }
}

@ICmsComponent<CmsInformationTilesComponent>({
    id: NCmsInformationTiles.componentId,
    name: 'Information tiles',
    onDemandOnly: true,
    fields: [
        <NICmsContentField.IRepeaterField>{
            type: NICmsContentField.EFieldType.repeater,
            key: 'tiles',
            title: 'Tiles',
            itemNameField: 'title',
            required: true,
            defaultSize: 3,
            fields: [
                {
                    type: NICmsContentField.EFieldType.choice,
                    key: 'icon',
                    title: 'Icon',
                    itemName: 'icon',
                    options: iconsOptions,
                    previewMode: 'icon',
                    default: 'icon-phone',
                    required: true
                },
                {
                    type: NICmsContentField.EFieldType.text,
                    key: 'title',
                    title: 'Title',
                    default: 'Title',
                    required: true
                },
                {
                    type: NICmsContentField.EFieldType.text,
                    key: 'description',
                    title: 'Description'
                },
                {
                    type: NICmsContentField.EFieldType.textarea,
                    key: 'copy',
                    title: 'Copy'
                }
            ]
        },
        NICmsContentComponent.backgroundField
    ]
})
@Component({
    standalone: true,
    imports: [ICmsClientModule, GridModule, NgClass],
    selector: 'cms-information-tiles',
    templateUrl: './cms-information-tiles.html',
    styleUrls: ['./cms-information-tiles.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CmsInformationTilesComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component?: NCmsInformationTiles.IComponentData;

    isSmallItem(index: number) {
        if (!this.component?.tiles?.length) {
            return true;
        }
        if ((this.component?.tiles?.length - 4) % 3 === 0) {
            return index > 3;
        }
        if ((this.component?.tiles?.length - 2) % 3 === 0) {
            return index > 1;
        }
        return true;
    }
}
